import React from 'react';
import './DeleteContactsForm.scss';
import { closeDeleteUserGroupContactsForm} from './contactsSlice';
import { userDeleteFromGroup } from '../../Authorization/authSlice';

const DeleteUserGroupContactsForm = (props) => {
    const { dispatch } = props;
 // CLICK OK
 
 const onSend = () => {
      
    console.log('Start delete group contact action');

        const data = {
            userId: props.userId,
            groupId: props.groupId,
        }
        console.log(data);

       dispatch(userDeleteFromGroup(data));
       
    
       dispatch(closeDeleteUserGroupContactsForm());
    }
    
    // CLOSE FORM
    const onClose = () => {
        const { dispatch } = props;
       
    dispatch(closeDeleteUserGroupContactsForm());
    

    }


    const render = () => {
        //console.log(this.props.adminState.openInputForms);
       // this.props.accountState.openClearHistoryForm)
        
            return(
                <div className="DeleteContactsForm">
                    
                <p><b>Вы действительно хотите удалить пользователя из группы?</b></p>
                
                <button onClick={onSend}>Да</button>
                <button onClick={onClose}>Отмена</button>
                </div>
            )
       
   
    }
return render();
}
export default DeleteUserGroupContactsForm;
  